<script>
import extended from './extended'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import isNull from 'lodash/isNull'
import groupBy from 'lodash/groupBy'
import maxBy from 'lodash/maxBy'

export default {
  name: 'FiltersDialog',
  props: {
    modelName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      extendedModel: {},
      common: {
        postcodeFrom: '',
        postcodeTo: '',
      },
      custom: {},
      numberComparisonOptions: [
        { value: 'equal', label: '=' },
        { value: 'more', label: '>' },
        { value: 'less', label: '<' },
        { value: 'notEqual', label: '≠' },
      ],
      hasFiltersValue: false,
    }
  },
  computed: {
    hasFilters() {
      if (this.modelName === 'CurrentUsageOfOilOnAMap') return false
      return true
    },
    hasCommonFilters() {
      if (
        this.modelName === 'UnresponsiveTransmittersAndPlugs' ||
        this.modelName === 'MergedButNotInitializedPlugs'
      )
        return false
      return true
    },
    hasPlugs() {
      return (
        this.modelName === 'OilVolumeChange' ||
        this.modelName === 'OpenedPlugs' ||
        this.modelName === 'PoorBattery' ||
        this.modelName === 'ToppingUpOil' ||
        this.modelName === 'ShipmentMistakes' ||
        this.modelName === 'InvalidMeasurement' ||
        this.modelName === 'CurrentOilVolume'
      )
    },
    hasPlugsOrTransmitters() {
      return (
        this.modelName === 'AvailabilityOfTransmittersInTheWorkshop' ||
        this.modelName === 'UnresponsiveTransmittersAndPlugs'
      )
    },
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
    hasExtendedModel() {
      return !isEmpty(this.extendedModel)
    },
    organizations() {
      const dict = this.$store.getters['data/getDictionary']('organization')
      return dict || []
    },
    regions() {
      const dict = this.$store.getters['data/getDictionary']('region')
      return dict || []
    },
    cities() {
      const dict = this.$store.getters['data/getDictionary']('city')
      return dict || []
    },
    oils() {
      const dict = this.$store.getters['data/getDictionary']('goods')
      return dict ? dict.filter(elem => elem.group === 1) : []
    },
    plugsOrTransmitterGroups() {
      const dict = this.$store.getters['data/getDictionary']('goodsgroup')
      return dict ? dict.filter(elem => elem.code === 2 || elem.code === 3)
      .map(item => {
        item.name = this.$t(`goodsgroup.${item.code}.name`)
        return item
      }): []
    },
    plugs() {
      const dict = this.$store.getters['data/getDictionary']('devices')
      return dict
        ? dict.filter(item => item.goodsGroup === 2 || item.goodsGroup === 5)
        : []
    },
    plugsAndTransmitters() {
      const dict = this.$store.getters['data/getDictionary']('devices')
      return dict || []
    },
    plugsAndTransmittersShippedOrMerged() {
      const dict = this.$store.getters['data/getDictionary']('devicestatuses')
      const bySerials = groupBy(dict, 'serial')
      let lastStatuses = Object.keys(bySerials)
        .map(serial => maxBy(bySerials[serial], 'lastUpdated'))
        .filter(item => item.statusCode === 2 || item.statusCode === 4)
      return lastStatuses.map(device => device.serial)
    },
    plugsShippedOrMerged() {
      const dict = this.$store.getters['data/getDictionary']('devicestatuses')
      const bySerials = groupBy(dict, 'serial')
      let lastStatuses = Object.keys(bySerials)
        .map(serial => maxBy(bySerials[serial], 'lastUpdated'))
        .filter(
          item =>
            (item.statusCode === 2 || item.statusCode === 4) &&
            (item.goodsGroup === 2 || item.goodsGroup === 5)
        )
      return lastStatuses.map(device => device.serial)
    },
    getPlugDrumOilsOrArticles() {
      const dict = this.$store.getters['data/getDictionary']('goods')
      let filter = dict
        ? dict.filter(elem => elem.group === 5 || elem.group === 6)
        : []
      return filter
    },
  },
  mounted() {
    this.getExtendedModel()
    this.getFiltersFromStore()
  },
  methods: {
    getExtendedModel() {
      if (!this.modelName) this.extendedModel = {}
      const extendedModel = extended[this.modelName]
      if (extendedModel) this.setExtendedModel(extendedModel)
      else this.extendedModel = {}
    },
    setExtendedModel(extendedModel) {
      this.custom = {}
      this.extendedModel = extendedModel
      extendedModel.forEach(elem => {
        if (elem.type === 'number') {
          this.custom = {
            ...this.custom,
            [elem.name]: {
              comparison: elem.default.comparison || 'equal',
              value: elem.default.value || null,
              organizationProperty: elem.organizationProperty,
            },
          }
        } else {
          this.custom = {
            ...this.custom,
            [elem.name]: [],
          }
        }
      })
    },
    getDictionary(field) {
      if (
        field.dictionary === 'devicestatuses' &&
        this.modelName === 'UnresponsiveTransmittersAndPlugs'
      ) {
        return this.plugsAndTransmittersShippedOrMerged
      }
      if (
        field.dictionary === 'devicestatuses' &&
        this.modelName === 'MergedButNotInitializedPlugs'
      ) {
        return this.plugsShippedOrMerged
      }
      if (
        field.dictionary === 'goods' &&
        this.modelName === 'MergedButNotInitializedPlugs'
      ) {
        return this.getPlugDrumOilsOrArticles
      }
      let dictionary = this.$store.getters['data/getDictionary'](
        field.dictionary
      )
      if (!dictionary) return []
      if (field.params) {
        field.params.forEach(param => {
          dictionary = dictionary.filter(
            elem => elem[param.key].toString() === param.value.toString()
          )
        })
      }
      return dictionary
    },
    getDeviceType(sourceDeviceType) {
      if (sourceDeviceType === 5) {
        return 2
      }
      return sourceDeviceType
    },
    closeModal() {
      this.show = false
    },
    clearFilters() {
      this.common = {
        region: [],
        city: [],
        organisation: [],
        postcodeFrom: '',
        postcodeTo: '',
        plugs: [],
        oil: [],
      }
      this.getExtendedModel()
      this.clear()
    },
    submit() {
      this.$emit(
        'set-filters',
        cloneDeep({
          common: this.common,
          custom: this.custom,
        })
      )
      this.setFiltersInStore()
      this.checkFilters()
      this.closeModal()
    },
    clear() {
      this.$emit(
        'clear-filters',
        cloneDeep({
          common: this.common,
          custom: this.custom,
        })
      )
      this.setFiltersInStore()
      this.checkFilters()
      this.closeModal()
    },
    setFiltersInStore() {
      this.$store.commit('filters/SET_FILTERS', {
        name: this.modelName,
        item: cloneDeep({
          common: this.common,
          custom: this.custom,
        }),
      })
    },
    getFiltersFromStore() {
      const filters = this.$store.state.filters.filters[this.modelName]
      if (filters) {
        const { common, custom } = filters
        this.common = cloneDeep(common)
        this.custom = cloneDeep(custom)
        this.submit()
      }
    },
    checkFilters() {
      let hasValue = false
      Object.keys(this.common).forEach(elem => {
        if (!isEmpty(this.common[elem])) hasValue = true
      })
      Object.keys(this.custom).forEach(elem => {
        if (Array.isArray(this.custom[elem])) {
          if (this.custom[elem].length > 0) hasValue = true
        } else {
          const { value } = this.custom[elem]
          if (typeof value !== 'string' && !isNull(value)) hasValue = true
        }
      })
      this.hasFiltersValue = hasValue
    },
  },
}
</script>

<template>
  <v-dialog
    v-if="hasFilters"
    v-model="show"
    persistent
    max-width="500px"
  >
    <v-btn
      slot="activator"
      :color="hasFiltersValue ? 'success' : 'info'"
    >
      <v-icon>filter_list</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__filter') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container
          fluid
          grid-list-md
        >
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-select
                v-if="hasCommonFilters"
                v-model="common.region"
                :items="regions"
                :label="$t(`label__region`)"
                item-text="name"
                item-value="code"
                clearable
                autocomplete
                multiple
              />
              <v-select
                v-if="hasCommonFilters"
                v-model="common.city"
                :items="cities"
                :label="$t(`label__city`)"
                item-text="name"
                item-value="code"
                clearable
                autocomplete
                multiple
              />
              <v-layout
                v-if="hasCommonFilters"
                row
              >
                <v-flex xs6>
                  <v-text-field
                    v-model="common.postcodeFrom"
                    :label="$t(`label__postcode_from`)"
                    type="string"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="common.postcodeTo"
                    :label="$t(`label__postcode_to`)"
                    type="string"
                  />
                </v-flex>
              </v-layout>
              <v-select
                v-if="hasCommonFilters"
                v-model="common.organisation"
                :items="organizations"
                :label="$t(`label__workshop`)"
                item-text="shortName"
                item-value="id"
                clearable
                autocomplete
                multiple
              />
              <v-select
                v-if="hasCommonFilters"
                v-model="common.oil"
                :items="oils"
                :label="$t(`label__oil_type`)"
                item-text="shortName"
                item-value="id"
                clearable
                autocomplete
                multiple
              />
              <v-select
                v-if="hasPlugs && hasCommonFilters"
                v-model="common.serial"
                :items="plugs"
                :label="$t('label__plugGuid')"
                :clearable="true"
                item-text="serial"
                item-value="serial"
                autocomplete
              />
              <v-select
                v-if="hasPlugsOrTransmitters && hasCommonFilters"
                v-model="common.serial"
                :items="plugsAndTransmitters"
                :label="$t('label__plugGuid')"
                :clearable="true"
                item-text="serial"
                item-value="serial"
                autocomplete
              />
              <template v-if="hasExtendedModel">
                <template v-for="field in extendedModel">
                  <v-select
                    v-if="field.type === 'select'"
                    :key="field.name"
                    v-model="custom[field.name]"
                    :items="getDictionary(field)"
                    :label="$t(`label__${field.label}`)"
                    :item-text="field.itemText"
                    :item-value="field.itemValue"
                    clearable
                    autocomplete
                    multiple
                  />
                  <v-layout
                    v-if="field.type === 'number'"
                    :key="field.name"
                    row
                  >
                    <v-flex xs2>
                      <v-select
                        v-model="custom[field.name].comparison"
                        :items="numberComparisonOptions"
                        item-text="label"
                        item-value="value"
                      />
                    </v-flex>
                    <v-flex xs10>
                      <v-text-field
                        v-model.number="custom[field.name].value"
                        :label="$t(`label__${field.label}`)"
                        type="number"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="field.type === 'goodsGroup'"
                    :key="field.name"
                    row
                  >
                    <v-flex xs12>
                      <v-select
                        v-model="custom[field.name]"
                        :items="plugsOrTransmitterGroups"
                        :label="$t(`label__${field.label}`)"
                        item-text="name"
                        item-value="code"
                        multiple
                        autocomplete
                        clearable
                      />
                  </v-flex></v-layout>
                </template>
              </template>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          @click="closeModal"
        >
          {{ $t('buttons__close') }}
        </v-btn>
        <v-btn
          color="secondary"
          @click="clearFilters"
        >
          {{ $t('buttons__clear_filters') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="submit"
        >
          {{ $t('buttons__confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
